import { createReducer, on } from '@ngrx/store';
import * as AirportListActions from './Airportlist.action';

export interface AirportListState {
  airports: any[];
  loading: boolean;
  error: any;
}

export const initialAirportListState: AirportListState = {
  airports: [],
  loading: false,
  error: null,
};

export const airportListReducer = createReducer(
  initialAirportListState,
  on(AirportListActions.loadAirportList, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(AirportListActions.loadAirportListSuccess, (state, { airports }) => ({
    ...state,
    airports,
    loading: false,
    error: null,
  })),
  on(AirportListActions.loadAirportListFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
